import { render, staticRenderFns } from "./PDFJSViewer.vue?vue&type=template&id=7e159377&scoped=true&"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js&"
import style0 from "./PDFJSViewer.vue?vue&type=style&index=0&id=7e159377&prod&lang=css&"
import style1 from "pdfvuer/dist/pdfvuer.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./PDFJSViewer.vue?vue&type=style&index=2&id=7e159377&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e159377",
  null
  
)

export default component.exports